/**
 * UserCreateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserCreateRes
 */
export interface UserCreateRes {
  /** 创建的用户ID */
  id?: string
}

/**
 * UserCreateRes Schema
 */
export const UserCreateResSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '创建的用户ID',
      format: 'string',
      type: 'string',
      label: '创建的用户ID',
    },
  },
  type: 'object',
}
